/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unstable-nested-components */

// React and hooks
import React, { useEffect, createRef, useState } from "react";

// Redux
import { useDispatch, useSelector } from "react-redux";
import setAlert from "store/actions/alertActions";
import {
  deleteTicket,
  clearErrors,
  getItemTickets,
  deleteSingleItem,
  setItemEmpty,
  updateTicketType,
  topFalseFn,
  topTrueFn,
  addTicketStep0,
} from "store/actions/itemAction";
import { getUserPartnerLocations, setLoading, setLocation } from "store/actions/locationAction";
import { clearFilters } from "store/actions/userActions";

// Material UI
import Grid from "@mui/material/Grid2";
import CancelIcon from "@mui/icons-material/Cancel";
import OfflinePinIcon from "@mui/icons-material/OfflinePin";

// Components
import MaterialTablePicker from "components/MaterialTablePicker";
import DashboardLayout from "layouts/DashboardLayout";
import Footer from "components/Footer";
import DashboardNavbar from "components/DashboardNavbar";
import MDBox from "components/MDBox";
import DynamicTabs from "components/DynamicTabs";
import LocationUserPartner from "components/locations/LocationUserPartner";
import columnsMap from "components/MaterialTablePicker/TableColumns";

const Tickets = () => {
  // Refs
  const tableRef = createRef();
  const dispatch = useDispatch();

  // Redux state selectors
  const loading = useSelector((state) => state.items.loading);
  const error = useSelector((state) => state.items.error);
  const user = useSelector((state) => state.users.user);
  const ticket = useSelector((state) => state.items.item);
  const locations = useSelector((state) => state.locations.locations);
  const locationPartner = useSelector((state) => state.locations.location);
  const added = useSelector((state) => state.items.added);
  const ticketType = useSelector((state) => state.items.ticketType);

  // Component state
  const [tabValue, setTabValue] = useState(0);
  const [onChangeLocationID, setOnChangeLocationID] = useState(false);
  const [locationId, setLocationId] = useState(locations[0]?._id);
  const [click, setClick] = useState(false);

  const handleChange = (option, val) => {
    if (ticket?.location?._id) dispatch(deleteSingleItem());
    if (locationPartner) dispatch(deleteSingleItem());

    tableRef.current.onQueryChange();
    setOnChangeLocationID(true);
    setLocationId(val?._id);
    dispatch(setLocation(val?._id));
    getItemTickets(val?._id);
  };

  useEffect(() => {
    dispatch(setItemEmpty());
    if (user?.role === "partner") {
      dispatch(setLoading());
      dispatch(getUserPartnerLocations());
    }
  }, []);

  useEffect(() => {
    if (ticketType?.type === "viator") {
      setTabValue(1);
    } else {
      setTabValue(0);
    }
  }, [ticketType?.type, added]);

  useEffect(() => {
    if (locations?.length > 0 && !ticket?.location?._id) {
      setLocationId(locations[0]?._id);
    }
  }, [locations]);

  // to add use Effect for set locaton ID when navigating back from edit-ticket
  useEffect(() => {
    if (ticket?.location?._id && locationId !== ticket?.location?._id) {
      setLocationId(ticket?.location?._id);
      dispatch(setLocation(locationId || ticket?.location?._id));
      getItemTickets(locationId || ticket?.location?._id);
    }
  }, [ticket?.location?._id, locationId]);

  useEffect(() => {
    // added is for delete to be removed direcly from the table
    if (click || added) {
      tableRef.current.onQueryChange();
      setClick(false);
    }
  }, [click, added]);

  useEffect(() => {
    dispatch(clearFilters());
  }, [tabValue]);

  // to add use Effect for set locaton ID when navigating back from new-ticket
  useEffect(() => {
    if (locationPartner && locationId !== locationPartner) {
      setLocationId(locationPartner);
      dispatch(setLocation(locationPartner));
      getItemTickets(locationPartner);
    }
  }, [locationPartner, locationId]);

  useEffect(() => {
    if (error) {
      dispatch(setAlert(error, "error"));
      dispatch(clearErrors());
    }
  }, [error, setAlert]);

  const deleteTicketFn = async (oldData) => {
    try {
      await dispatch(deleteTicket(oldData?._id));
      dispatch(clearErrors());
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Error deleting ticket:", err);
    }
  };

  const handleFalseTop = (id) => {
    dispatch(setLoading());
    dispatch(topFalseFn(id));
    setClick(true);
  };
  const handleTopTrue = (id) => {
    dispatch(setLoading());
    dispatch(topTrueFn(id));
    setClick(true);
  };

  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === 0) {
      dispatch(setLoading());

      dispatch(updateTicketType({ type: "lokalee" }));
    }
    if (newValue === 1) {
      dispatch(updateTicketType({ ...ticketType, type: "viator" }));
    }
  };

  const refreshPage = () => {
    window.location.reload(true);
  };

  const getApiUrl = () => {
    if (user?.role === "admin") {
      return `${process.env.REACT_APP_API}/tickets?source=lokalee&`;
    }
    if (onChangeLocationID && user?.role === "partner") {
      return `/v2/tickets?location=${locationId}&source=lokalee&`;
    }
    if (ticket?.location?._id && ticket?.location?._id !== locationId && user?.role === "partner") {
      return `/v2/tickets?location=${ticket?.location?._id}&source=lokalee&`;
    }
    if (locationPartner && locationPartner !== locationId && user?.role === "partner") {
      return `/v2/tickets?location=${locationPartner}&source=lokalee&`;
    }
    return `/v2/tickets?location=${locationId}&source=lokalee&`;
  };

  const updateTicketFn = (data) => {
    const updatedData = {
      _id: data._id,
      title: data.title,
      city: data.city,
      availability_type: data.availability_type,
      source: data.source,
      itemType: data.itemType,
      availabilities: data.availabilities,
      curator: data.curator,
      curatorOrProv: data?.provider?.name?.length > 0 ? "provider" : "curator",
    };
    // dispatch(updateTicket(updatedData));
    dispatch(addTicketStep0(updatedData, data?._id));
  };

  const detailTabs = [
    { id: 1, title: "Lokalee tickets" },
    { id: 2, title: "Viator tickets", disabled: user?.role === "partner" },
  ];

  const actionsChildFn = (rowData) => {
    let actionsChildRole = {};
    actionsChildRole = {
      icon: rowData.top ? CancelIcon : OfflinePinIcon,
      tooltip: rowData.top ? "Top false" : "Top true",

      iconProps: {
        style: {
          marginLeft: "10px",
          fontSize: "25px",
          color: rowData.top ? "#f50057" : "green",
        },
      },
      onClick: () => {
        // eslint-disable-next-line no-unused-expressions
        rowData.top ? handleFalseTop(rowData._id) : handleTopTrue(rowData._id);
        refreshPage();
      },
    };
    return actionsChildRole;
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container justifyContent="left" pt={3} pb={3}>
        <Grid size={{ xs: 4 }}>
          <Grid container direction="column">
            <Grid>
              {user?.role === "partner" && locationId && (
                <LocationUserPartner
                  defaultLocationId={locationId}
                  handleChange={handleChange}
                  locations={locations || {}}
                />
              )}
            </Grid>
            {user?.role !== "partner" && (
              <Grid>
                <MDBox>
                  <DynamicTabs
                    ticketPage
                    detailTabs={detailTabs}
                    userRole={user?.role}
                    tabValue={tabValue}
                    handleSetTabValue={handleSetTabValue}
                  />
                </MDBox>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>

      <Grid size={{ xs: 12 }}>
        {(user.role === "partner" && locationId) || user.role === "admin" ? (
          tabValue === 0 ? (
            <MaterialTablePicker
              key={tabValue}
              screen="TicketsList"
              ticketsTable
              title=""
              columns={[
                columnsMap.titleCol,
                columnsMap.tag,
                columnsMap.tagstheme,
                columnsMap.primaryDestinationWithFilter,
                columnsMap.currencyNoDefault,
                columnsMap.fromPrice,
                columnsMap.approvalStatusBool,
                columnsMap.topCol,
              ]}
              extraFields="tags,slug,source,availability_type,itemType,availabilities,curator,provider"
              tableRef={tableRef}
              asyncTable
              sortField="title"
              onRowClickHandler="item"
              searchField="tickets"
              exportMenuField="items"
              itemType="ticket"
              isLoading={loading}
              idSynonymName="_id"
              currentUrl="tickets"
              asyncURL={getApiUrl()}
              addUrl={
                user.role === "admin"
                  ? `tickets/new-ticket`
                  : `tickets/new-ticket?locationId=${locationId}`
              }
              actionsName="Ticket"
              onRowClickURL={`/${user.role}/tickets`}
              editableUpdate={updateTicketFn}
              editableDelete={deleteTicketFn}
              actionsChild={actionsChildFn}
              updateRoleAction
              deleteRoleAction
              editableRole={user.role === "admin"}
              actionsRole={user.role === "admin" || user.role === "partner"}
            />
          ) : (
            <MaterialTablePicker
              key={tabValue}
              screen="TicketsList"
              title=""
              ticketsTable
              columns={[
                columnsMap.titleCol,
                columnsMap.tag,
                columnsMap.tagstheme,
                columnsMap.primaryDestinationField,
                columnsMap.currencyWithFilter,
                columnsMap.fromPrice,
                columnsMap.approvalStatusWithFilter,
                columnsMap.topFilterDisabled,
              ]}
              extraFields="tags,slug,source"
              tableRef={tableRef}
              asyncTable
              sortField="title"
              onRowClickHandler="item"
              searchField="tickets"
              exportMenuField="items"
              itemType="ticket"
              isLoading={loading}
              idSynonymName="_id"
              currentUrl="tickets"
              actionsChild={actionsChildFn}
              // asyncURL={`${process.env.REACT_APP_API}/tickets?source=viator&`}
              asyncURL={
                user.role === "admin"
                  ? `${process.env.REACT_APP_API}/tickets?source=viator&`
                  : onChangeLocationID && user?.role === "partner"
                  ? `/v2/tickets?location=${locationId}&source=viator&`
                  : ticket?.location?._id &&
                    ticket?.location?._id !== locationId &&
                    user?.role === "partner"
                  ? `/v2/tickets?location=${ticket?.location?._id}&source=viator&`
                  : locationPartner && locationPartner !== locationId && user?.role === "partner"
                  ? `/v2/tickets?location=${locationPartner}&source=viator&`
                  : `/v2/tickets?location=${locationId}&source=viator&`
              }
              actionsName="Ticket"
              isRowClickable={false}
              // actionsRole (no add btn for viator tickets)
            />
          )
        ) : null}
      </Grid>
      <Footer />
    </DashboardLayout>
  );
};

export default Tickets;
